// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as SaveDetailsCheckbox$OrcaPaymentPage from "./SaveDetailsCheckbox.bs.js";

function ClickToPayDetails(props) {
  var setIsClickToPayRememberMe = props.setIsClickToPayRememberMe;
  var clickToPayCardBrand = props.clickToPayCardBrand;
  var setIsSaveDetailsWithClickToPay = props.setIsSaveDetailsWithClickToPay;
  var clickToPayConfig = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.clickToPayConfig);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var iframeId = match$1.iframeId;
  var isUnrecognizedUser = Core__Option.getOr(clickToPayConfig.clickToPayCards, []).length === 0;
  var css = SaveDetailsCheckbox$OrcaPaymentPage.saveDetailsCssStyle(match.themeObj);
  var getPrivacyNoticeUrl = function () {
    var match = clickToPayCardBrand.toLowerCase();
    switch (match) {
      case "visa" :
          return "https://www.visa.com.hk/en_HK/legal/global-privacy-notice.html";
      default:
        return "https://www.mastercard.com/global/click-to-pay/en-us/privacy-notice.html";
    }
  };
  var getTermsUrl = function () {
    var match = clickToPayCardBrand.toLowerCase();
    switch (match) {
      case "visa" :
          return "https://www.visa.com.hk/en_HK/legal/visa-checkout/terms-of-service.html";
      default:
        return "https://www.mastercard.com/global/click-to-pay/en-us/terms-of-use.html";
    }
  };
  var handleOpenUrl = function ($$event, url) {
    $$event.preventDefault();
    open(url, "_blank", "");
  };
  var capitalizeCardBrand = function (brand) {
    return brand.substring(0, 1).toUpperCase() + brand.substring(1, brand.length);
  };
  var formattedCardBrand = capitalizeCardBrand(clickToPayCardBrand);
  var match$2 = props.isSaveDetailsWithClickToPay ? [
      "Checkbox--checked",
      "CheckboxInput--checked",
      "CheckboxLabel--checked"
    ] : [
      "",
      "",
      ""
    ];
  var isSaveDetailsCheckedState = match$2[1];
  var match$3 = props.isClickToPayRememberMe ? [
      "Checkbox--checked",
      "CheckboxInput--checked",
      "CheckboxLabel--checked"
    ] : [
      "",
      "",
      ""
    ];
  var isRememberMeCheckedState = match$3[1];
  var handleLearnMore = function (param) {
    var cardBrands = clickToPayConfig.availableCardBrands.map(function (brand) {
          return brand;
        });
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
          [
            "fullscreen",
            true
          ],
          [
            "param",
            "clickToPayLearnMore"
          ],
          [
            "iframeId",
            iframeId
          ],
          [
            "metadata",
            Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                    "cardBrands",
                    cardBrands
                  ]])
          ]
        ]);
  };
  return React.createElement(React.Fragment, {}, React.createElement("style", undefined, css), isUnrecognizedUser ? React.createElement(React.Fragment, {}, React.createElement("style", undefined, css), React.createElement("div", {
                        className: "Checkbox " + match$2[0] + " flex"
                      }, React.createElement("label", {
                            className: "container CheckboxInput " + isSaveDetailsCheckedState,
                            style: {
                              width: "fit-content"
                            }
                          }, React.createElement("input", {
                                type: "checkbox",
                                onChange: (function (e) {
                                    setIsSaveDetailsWithClickToPay(e.target.checked);
                                  })
                              }), React.createElement("div", {
                                className: "checkmark CheckboxInput " + isSaveDetailsCheckedState
                              })), React.createElement("div", {
                            className: "CheckboxLabel " + match$2[2] + " ml-2 w-11/12 text-xs space-y-2",
                            style: {
                              color: "#a9a9a9"
                            }
                          }, React.createElement("div", undefined, "Save my information with " + formattedCardBrand + " ", React.createElement("span", {
                                    className: "underline decoration-1 underline-offset-2 cursor-pointer",
                                    onClick: handleLearnMore
                                  }, "Click to Pay"), " ", "for a faster and secure checkout"), React.createElement("div", undefined, "Your email or mobile number will be used to verify you.", "Message/data rates may apply."))), React.createElement("div", {
                        className: "Checkbox " + match$3[0] + " flex"
                      }, React.createElement("label", {
                            className: "container CheckboxInput " + isRememberMeCheckedState,
                            style: {
                              width: "fit-content"
                            }
                          }, React.createElement("input", {
                                type: "checkbox",
                                onChange: (function (e) {
                                    setIsClickToPayRememberMe(e.target.checked);
                                  })
                              }), React.createElement("div", {
                                className: "checkmark CheckboxInput " + isRememberMeCheckedState
                              })), React.createElement("div", {
                            className: "CheckboxLabel " + match$3[2] + " ml-2 w-11/12 text-xs space-y-2",
                            style: {
                              color: "#a9a9a9"
                            }
                          }, React.createElement("div", {
                                className: "flex items-center"
                              }, "Remember me on this browser", React.createElement("div", {
                                    className: "relative inline-block ml-2"
                                  }, React.createElement("div", {
                                        className: "group cursor-help"
                                      }, React.createElement("div", {
                                            className: "w-4 h-4 rounded-full bg-[#4a4a4a] flex items-center justify-center cursor-help"
                                          }, React.createElement("span", {
                                                className: "text-white text-xs cursor-help",
                                                style: {
                                                  fontSize: "10px"
                                                }
                                              }, "i")), React.createElement("div", {
                                            className: "invisible group-hover:visible absolute z-10 w-64 bg-white text-xs rounded-md p-2 left-1/2 transform -translate-x-1/2 bottom-[150%] shadow-md border border-gray-200 before:content-[''] before:absolute before:top-[100%] before:left-1/2 before:ml-[-5px] before:border-[5px] before:border-solid before:border-gray-200 before:border-b-transparent before:border-l-transparent before:border-r-transparent after:content-[''] after:absolute after:top-[100%] after:left-1/2 after:ml-[-4px] after:border-[4px] after:border-solid after:border-white after:border-b-transparent after:border-l-transparent after:border-r-transparent"
                                          }, React.createElement("div", {
                                                className: "flex flex-col space-y-2"
                                              }, React.createElement("span", undefined, "When remembered, you'll skip verification and securely", "access your saved cards when paying with Click to Pay."), React.createElement("span", undefined, "Not recommended for public or shared devices because", "this uses cookies.")))))), React.createElement("div", undefined, "By continuing, you agree to " + formattedCardBrand + "'s ", React.createElement("span", {
                                    className: "underline decoration-1 underline-offset-2 cursor-pointer",
                                    onClick: (function (ev) {
                                        handleOpenUrl(ev, getTermsUrl());
                                      })
                                  }, "Terms"), " ", "and understand your data will be processed according to the ", React.createElement("span", {
                                    className: "underline decoration-1 underline-offset-2 cursor-pointer",
                                    onClick: (function (ev) {
                                        handleOpenUrl(ev, getPrivacyNoticeUrl());
                                      })
                                  }, "Privacy Notice"), ".")))) : React.createElement("div", {
                    className: "text-xs font-normal"
                  }, "By continuing, " + clickToPayConfig.dpaName + " will share your card details, billing address,\n        and email with " + formattedCardBrand + " to allow you to securely enroll in Click to\n        Pay for faster checkouts.", " ", React.createElement("span", {
                        className: "underline decoration-1 underline-offset-2 cursor-pointer",
                        onClick: handleLearnMore
                      }, "Learn more")));
}

var make = ClickToPayDetails;

export {
  make ,
}
/* react Not a pure module */
